<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { usePartnerStore } from '@/stores/usePartnerStore'
import { watch } from 'vue'
import { useToast } from 'vue-toast-notification'
const $toast = useToast()
const partnerStore = usePartnerStore()
const { searchValue, isActive } = storeToRefs(partnerStore)
watch(
  isActive,
  () => {
    if (!isActive.value) {
      $toast.error(`${searchValue.value} n'a pas été trouvée, veuillez vérifier qu'elle existe bien sur Odoo, le cas échéant sur Pappers / societe.com.`, {
        duration: 5000,
      })
    }
  },
  { immediate: true },
)
</script>

<template>
  <div class="flex flex-col items-center justify-center bg-white">
    <p class="text-2xl font-bold mt-5">Aucun résultat trouvé</p>
    <img
      class="m-auto w-1/3"
      src="@/assets/images/nothing-here-flat-illustration.jpg"
      alt="nothing"
    />
  </div>
</template>
